import { Suspense, lazy, ReactElement } from "react";
import { Spinner } from "@vwfs-bronson/bronson-react";

const CUPRA = lazy(() => import("./cupra"));
const SEAT = lazy(() => import("./seat"));
const AUDI = lazy(() => import("./audi"));
const VW = lazy(() => import("./vw"));
const VWN = lazy(() => import("./vwn"));
const SKODA = lazy(() => import("./skoda"));

export const ThemeSelector = ({ children }: { children: ReactElement }) => {
    const theme = process.env.REACT_APP_WEBSITE_THEME;
    return (
        <>
            <Suspense fallback={<Spinner fullPage></Spinner>}>
            
                {theme === "seat_it" && <SEAT>{children}</SEAT>}
                {theme === "cupra_it" && <CUPRA>{children}</CUPRA>}
                {theme === "audi_it" && <AUDI>{children}</AUDI>}
                {theme === "vw_it" && <VW>{children}</VW>}
                {theme === "vwn_it" && <VWN>{children}</VWN>}
                {theme === "skoda_it" && <SKODA>{children}</SKODA>}
            </Suspense>
        </>
    );
};
